import React, { useMemo } from "react";
import "../components/Hero.css";

export default function Hero() {
  return (
    <div>
      <section className="hero">
        <h1 className="hero_title">
          <span className="hero_title-bold">Save Big.</span>{" "}
          <span className="hero_title-italic">Dress Better.</span>
        </h1>
        <p className="hero_subtitle1">
          Discover trending sales from brands you love.
        </p>
        <p className="hero_subtitle2">
          Real-time fashion deals from Nike, Zara, Lacoste, and more.
        </p>
        <div className="decor decor-left">
          <div className="decorText">SALE</div>
        </div>
        <div className="decor decor-right">
          <div className="decorText">SALE</div>
        </div>
      </section>
    </div>
  );
}
